import { SVGCheck, SVGMail, SVGUnion, USAFlag } from "@/images/svg/svg-icons";
import classNames from "classnames";
import React, { Dispatch, SetStateAction, useState } from "react";
export interface Step1Props {
  story: any;
  isPhoneSuccess: boolean;
  setValuePhone: Dispatch<SetStateAction<string>>;
  setValueMail: Dispatch<SetStateAction<string>>;
  setIsPhoneSuccess: Dispatch<SetStateAction<boolean>>;
  setIsMailSuccess: Dispatch<SetStateAction<boolean>>;
  valuePhone: string;
  valueMail: string;
  isMailSuccess: boolean;
  notValidPhone: boolean;
  setNotValidPhone: Dispatch<SetStateAction<boolean>>;
}
export default function Step1({
  story,
  isPhoneSuccess,
  setIsPhoneSuccess,
  setIsMailSuccess,
  setValuePhone,
  setValueMail,
  valuePhone,
  valueMail,
  isMailSuccess,
  notValidPhone,
  setNotValidPhone,
}: Step1Props) {
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [isMailError, setIsMailError] = useState(false);

  function onTelChange(e: any) {
    setNotValidPhone(false);
    setValuePhone(e.target.value);
    if (isPhoneError) {
      if (e.target.value.length === 10) {
        setIsPhoneError(false);
      } else {
        setIsPhoneError(true);
      }
    }
    if (e.target.value.length === 10) {
      setIsPhoneSuccess(true);
    } else {
      setIsPhoneSuccess(false);
    }
  }

  function onBlurPhone() {
    setNotValidPhone(false);
    if (valuePhone.length != 10) {
      setIsPhoneError(true);
    } else {
      setIsPhoneError(false);
    }
    if (valuePhone.length === 10) {
      setIsPhoneSuccess(true);
    } else {
      setIsPhoneSuccess(false);
    }
  }

  function onMailChange(e: any) {
    setValueMail(e.target.value);
    const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const valid = re.test(String(e.target.value).toLowerCase());
    if (valid) {
      setIsMailSuccess(true);
      setIsMailError(false);
    } else {
      setIsMailSuccess(false);
    }
  }

  function onBlurMail() {
    const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const valid = re.test(String(valueMail).toLowerCase());
    setIsMailError(!valid);
  }
  return (
    <>
      <p className="text-main-black text-base p-4">{story.description}</p>
      <div className="p-4">
        <p className="text-main-black text-base mb-2">
          Enter your mobile number
        </p>
        <div className="flex items-stretch pb-4 mb-4 relative">
          <div className="h-auto w-[68px] flex items-center justify-center bg-main-gray rounded border-[#CED4DA] border-[1px]">
            <USAFlag />
            <p className="text-main-black text-base ml-3">+1</p>
          </div>
          <input
            type="tel"
            maxLength={10}
            className={classNames(
              "input-default",
              isPhoneError && "border-main-error",
              isPhoneSuccess && "border-main-success shadow-none pr-8"
            )}
            placeholder="4844731411"
            onChange={onTelChange}
            onBlur={onBlurPhone}
            inputMode={"numeric"}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
          {isPhoneSuccess && (
            <div className="absolute top-[12px] right-3">
              <SVGCheck />
            </div>
          )}
          {isPhoneError && (
            <>
              <div className="absolute top-[12px] right-3 h-4 w-4">
                <SVGUnion />
              </div>
              <p className="text-main-error absolute -bottom-1 text-sm">
                Phone number must be 10-digit
              </p>
            </>
          )}
          {notValidPhone && (
            <>
              <div className="absolute top-[12px] right-3 h-4 w-4">
                <SVGUnion />
              </div>
              <p className="text-main-error absolute -bottom-1 text-sm">
                The phone number is not valid
              </p>
            </>
          )}
        </div>
        <div className="">
          <p className="text-main-black text-base mb-2">Enter your email</p>
          <div className="relative pb-4">
            <div className="absolute left-3 top-[12px]">
              <SVGMail />
            </div>
            <input
              type="email"
              className={classNames(
                "input-default pl-8",
                isMailError && "border-main-error",
                isMailSuccess && "border-main-success shadow-none pr-8"
              )}
              placeholder="youremail@mail.com"
              onChange={onMailChange}
              onBlur={onBlurMail}
            />
            {isMailSuccess && (
              <div className="absolute top-[12px] right-3">
                <SVGCheck />
              </div>
            )}
            {isMailError && (
              <>
                <div className="absolute top-[12px] right-3 h-4 w-4">
                  <SVGUnion />
                </div>
                <p className="text-main-error text-sm">
                  Please enter an email address in the correct format
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
